import React, { useState } from "react";
import chip from "../../../images/chip.png";
import CardForm from "./CardForm";
import contractless from "../../../images/contractless.png";
import { format } from "date-fns";
import { toast } from "react-toastify";
import ClearIcon from "@mui/icons-material/Clear";
import { MyGlobalContext } from "../../../Context";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Card = ({ value, setIsPaymentTrue, setisPaymentPopUpConfirmed }) => {
  const { localCart, totalItem, totalPrice, token, toggleRun, toggleRunPath } =
    MyGlobalContext();
  const navigate = useNavigate();
  const [bankName, setBankName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [cardHolder, setCardHolder] = useState("");
  const [cardExpire, setCardExpire] = useState("");
  const [cvv, setCvv] = useState("");
  const [isRotate, setIsRotate] = useState(false);
  const rotate = () => {
    setIsRotate(!isRotate);
  };

  const styleToast = {
    position: "top-center",
    autoClose: 5000,
  };
  function isCardNumberValid(cardNumber) {
    const regex = /^(\d{4}\s){3}\d{4}$/;
    return regex.test(cardNumber);
  }
  // this is the payment bank card onSubmit function
  // console.log(bankName, typeof bankName);
  const OnSubmitPayment = (e) => {
    e.preventDefault();
    if (
      bankName !== "" &&
      cardNumber !== "" &&
      cardHolder !== "" &&
      cardExpire !== "" &&
      cvv !== ""
    ) {
      if (cardNumber.length === 19 && isCardNumberValid(cardNumber)) {
        axios
          .post(
            "https://cocktailshop.onrender.com/purchase/payment/complete",
            {
              bankCardDetails: {
                bankName,
                cardNumber,
                cardHolder,
                cardExpire,
                cvv,
              },
              products: localCart,
              totalItem,
              totalPrice,
            },
            { headers: { Authorization: token }, withCredentials: true }
          )
          .then((res) => {
            if (res.status === 201) {
              toast.success("Payment Successful!", styleToast);
              localStorage.removeItem("CocktailCart");
              setIsPaymentTrue(false);
              setisPaymentPopUpConfirmed(false);
              toggleRun();
              navigate("/profile");
              toggleRunPath();
            }
          })
          .catch((err) => {
            console.log(err);
            const status = err.response.status;
            const message = err.response.data.message;

            if (status === 500) {
              toast.warn(message, styleToast);
            } else if (status === 422) {
              toast.warn(message, styleToast);
            } else {
              toast.warn(message, styleToast);
            }
          });
        // console.log(cardNumber.length);
      } else {
        // console.log(cardNumber.length);
        toast.warn(
          "Bank Card number must be 16 digit and contains only nubmers!",
          styleToast
        );
      }
    } else {
      toast.warn("Please fill all the inputs and try again!", styleToast);
    }
  };
  return (
    <article className="w-[90vw] md:w-[750px] flex justify-between items-center bal-card px-2 py-5">
      <button
        onClick={() => setisPaymentPopUpConfirmed(false)}
        className="absolute top-[-10px] text-[30px] left-[4px] text-[white] payment-cross-btn z-50"
      >
        <ClearIcon sx={{ fontSize: "30px" }} />
      </button>
      <div
        onClick={rotate}
        className="h-[190px!important] w-[100%] max-w-[300px] card-display-details relative rounded-xl mx-auto"
      >
        <div className={`${isRotate && "rotate"}`}>
          <div className="flex justify-between items-center px-4 pt-3 font-medium uppercase text-white">
            <h1 className="bank-name-shadow">{bankName || "boc"}</h1>
            <h1 className="bank-name-shadow font-extrabold">{value} card</h1>
          </div>
          <img src={chip} alt="" className=" w-10  mt-2 ml-4" />
          <h1 className=" card-numberX">
            {cardNumber || "XXXX XXXX XXXX XXXX"}
          </h1>
          <h5 className=" absolute bottom-3 left-4 font-semibold tracking-wide text-[11px] text-white bank-name-shadow uppercase">
            {cardHolder || "card holder"}
          </h5>
          <div className=" absolute right-2 bottom-3 uppercase text-white">
            <p className=" text-[7px] text-center bank-name-shadow ml-8">
              Month/year
            </p>
            <div className="flex items-center w-[100px] justify-end pr-3">
              <p className="text-[7px] card-exp mr-2">Exp:</p>
              <p className="card-exp text-[13px]">
                {format(new Date(cardExpire || null), "MM/yy")}
              </p>
            </div>
          </div>
        </div>
        <div className={`${!isRotate ? "showCvc" : ""}`}>
          <p className="text-[10px] text-white tracking-widest ml-3 mt-[2px]">
            https://www.{bankName.toLowerCase()}.com
          </p>
          <h1 className=" w-[100%] h-10 bg-black absolute top-5 cvv-black-cvv-white"></h1>
          <h1 className="w-[65%] h-[2.3rem] bg-[#d4d4d4] absolute bottom-20 left-2 flex items-center justify-end px-2 text-white shadow-md  rounded-sm cvv-black-cvv-white cvv-single">
            {cvv || "XXX"}
          </h1>
          <img
            src={contractless}
            alt=""
            className="absolute w-[24px] bottom-20 right-3 mb-1 cvv-single"
          />
          <p className="absolute text-white text-[10px] bottom-[63px] left-[50%] translate-x-[-50%] authorized-sig-small">
            Authorized Signature
          </p>
          <ul className="text-[10px] absolute bottom-[-14px] p-4 tracking-wide text-white block ul-bank-card-regulation regulation-card">
            <li>
              The use of this card, you must comply with the {value} Card
              Regulation of {bankName.toUpperCase()}.
            </li>
            <li>
              If the cardholder loses this card, please report the loss to our
              bank as soon as possible.
            </li>
          </ul>
        </div>
      </div>
      <CardForm
        setBankName={setBankName}
        setCardNumber={setCardNumber}
        cardNumber={cardNumber}
        setCardHolder={setCardHolder}
        setCardExpire={setCardExpire}
        setIsRotate={setIsRotate}
        setCvv={setCvv}
        OnSubmitPayment={OnSubmitPayment}
      />
    </article>
  );
};

export default Card;
